const achievements = [
  {
    id: 1,
    image: "/data/achievements/achievement01.png",
    imageViewed: "/data/achievements/achievement01_viewed.png",
    title: "Manpuku-ji",
    subtitle: "Sanmon Gate",
    name: "sanmon_gate",
  },
  {
    id: 2,
    image: "/data/achievements/achievement02.png",
    imageViewed: "/data/achievements/achievement02_viewed.png",
    title: "Mirokubosatsu",
    subtitle: null,
    name: "maitreya_bodhisattva",
  },
  {
    id: 3,
    image: "/data/achievements/achievement03.png",
    imageViewed: "/data/achievements/achievement03_viewed.png",
    title: "Idaten",
    subtitle: null,
    name: "idaten",
  },
  {
    id: 4,
    image: "/data/achievements/achievement04.png",
    imageViewed: "/data/achievements/achievement04_viewed.png",
    title: "Kaipan",
    subtitle: null,
    name: "kaipan",
  },
  {
    id: 5,
    image: "/data/achievements/achievement05.png",
    imageViewed: "/data/achievements/achievement05_viewed.png",
    title: "Daihououden",
    subtitle: null,
    name: "daiyu_hoden",
  },
  {
    id: 6,
    image: "/data/achievements/achievement06.png",
    imageViewed: "/data/achievements/achievement06_viewed.png",
    title: "Eighteen",
    subtitle: "Arhats statues",
    name: "statue_of_venerable_rahula",
  },
  {
    id: 7,
    image: "/data/achievements/achievement07.png",
    imageViewed: "/data/achievements/achievement07_viewed.png",
    title: "Hatto",
    subtitle: null,
    name: "dharma_hall",
  },
  {
    id: 8,
    image: "/data/achievements/achievement08.png",
    imageViewed: "/data/achievements/achievement08_viewed.png",
    title: "Touhojo",
    subtitle: null,
    name: "east_abbots_quarters",
  },
  {
    id: 9,
    image: "/data/achievements/achievement09.png",
    imageViewed: "/data/achievements/achievement09_viewed.png",
    title: "Zendou",
    subtitle: null,
    name: "zen_hall",
  },
  {
    id: 10,
    image: "/data/achievements/achievement10.png",
    imageViewed: "/data/achievements/achievement10_viewed.png",
    title: "Kaisando",
    subtitle: null,
    name: "founders_hall",
  },
];

export default achievements;
